// LoadingSpinner component

import React from 'react';

const sizes = {
  small: 'w-4 h-4 border-2',
  medium: 'w-8 h-8 border-3',
  large: 'w-12 h-12 border-4',
  xlarge: 'w-16 h-16 border-4',
};

const LoadingSpinner = ({
  size = 'medium',
  color = 'primary',
  className = '',
}) => {
  const colorClasses = {
    primary: 'border-primary-500',
    secondary: 'border-secondary-500',
    white: 'border-white',
    dark: 'border-dark-900',
  };

  return (
    <div
      className={`
        animate-spin rounded-full
        border-t-transparent
        ${sizes[size] || sizes.medium}
        ${colorClasses[color] || colorClasses.primary}
        ${className}
      `}
      style={{ borderStyle: 'solid', borderTopStyle: 'solid', borderTopColor: 'transparent' }}
    />
  );
};

export const LoadingOverlay = ({ message = 'Loading...' }) => (
  <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center z-50">
    <LoadingSpinner size="large" />
    <p className="mt-4 text-dark-600">{message}</p>
  </div>
);

export const LoadingPage = ({ message = 'Loading...' }) => (
  <div className="min-h-screen bg-dark-50 flex flex-col items-center justify-center">
    <LoadingSpinner size="xlarge" />
    <p className="mt-4 text-dark-600 text-lg">{message}</p>
  </div>
);

export default LoadingSpinner;
